<template>
    <div>
        <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100"
            leave-to-class="opacity-0">
            <div class="fixed inset-0 transition-opacity z-50">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
        </transition>
        <div class="block modal mt-14" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content ticket">
                    <div class="modal-header">
                        <h4 class="modal-title font-normal" id="modalTitle">{{ inspectionTicketModalTitle }}</h4>
                        <button @click.prevent="closeModal()" aria-hidden="true" class="text-lg">×</button>
                    </div>

                    <div class="modal-body">
                        <!-- Add items to existing ticket -->
                        <div class="form">
                            <div class="form-group">
                                <label for="ticket-list">Select Ticket</label>
                                <div id="ticket-list">
                                    <select-ticket
                                        :api="'/assets/' + inspection.asset_id + '/tickets'"
                                        v-model="form.ticket"
                                    ></select-ticket>
                                </div>

                                <span
                                    class="invalid-feedback"
                                    :class="{'d-block': form.errors.has('ticket')}"
                                    v-show="form.errors.has('ticket')">
                                    {{ form.errors.get("ticket") }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button
                            class="btn btn-success waves-effect waves-light"
                            @click.prevent="link"
                            :disabled="form.busy">
                            {{ form.busy ? "Adding..." : "Add Items" }}
                        </button>

                        <button
                            @click.prevent="closeModal()"
                            class="btn btn-default waves-effect"
                            :disabled="form.busy">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        inspection: {
            type: Object,
            required: true,
        },
        selectedChecklistItems: {
            type: Array,
            required: true,
            description: "The selected checklist items to add to the ticket"
        },
    },

    data () {
        return {
            selectedServiceProvider: null,
            form: new AppForm({}),
        };
    },

    computed: {
        inspectionTicketModalTitle () {
            if (this.selectedChecklistItems.length === 1) {
                return "Add Item To Ticket";
            }
            if (this.selectedChecklistItems.length > 1) {
                return "Add " + this.selectedChecklistItems.length + " Items To Ticket";
            }
            return "Add Items To Ticket";
        },
    },

    methods: {
        link () {
            this.form.checklist_items = this.selectedChecklistItems.map(item => item.id);
            App.patch(`/inspections/${this.inspection.id}/tickets/update`, this.form)
            .then((response) => {
                Bus.$emit("ticket-linked", response);
                toastr.success("Items added to ticket!");
            }).catch(error => {
                toastr.error("Error Linking To Ticket! Error: " + error.message);
            });
        },

        closeModal () {
            this.$emit("close");
        },
    },
};
</script>
